export default __webpack_public_path__ + "static/media/partner-5.9bc1cd76.png";